$.fn.toggleCategories = function() {

  $('#categoryList .category-item, #categoryList .category-sub-item').on("click", function () {
      var plusMinusSign = $(this);

      plusMinusSign.siblings('ul:first').toggle(0,  function() {
          var subCategory = $(this);

          if (plusMinusSign.hasClass('categoryChild-close')) {

            plusMinusSign.addClass('categoryChild-open');
            plusMinusSign.removeClass('categoryChild-close');

          } else {

            plusMinusSign.addClass('categoryChild-close');
            plusMinusSign.removeClass('categoryChild-open');
          }
      });
  });
}

$(function() {
  $.fn.toggleCategories();

  // collapse the topmost level only
  $('.collapse-by-default').trigger("click");

  // display after render
  $('.js_categoryList').removeClass('hide')
});